module.exports = __webpack_public_path__ + "static/dorishowe1-da63ae0d58396edaff6820c2220bdb31.png";